export const EconsultProviderTypes = {
  consultant: 'consultant',
  referrer: 'referrer'
};
